import * as React from 'react'
import { connect } from 'react-redux'
import { Grid } from 'semantic-ui-react'

import { SelectField as _SelectField } from '../../formfields/select-field'
import { CommentItemField } from '../../formfields/comment-field'
import Qtext from '../../qtext.js'
import withToggle from '../../../enhancers/toggleable'
import connectField from '../../../enhancers/connect-field'

const SelectField = withToggle(connectField(_SelectField))

const mstp = (state, props) => {
  return { rowComment: state.data[props.currentPageName][props.name]['_rowcomment'] }
}
class _List extends React.PureComponent {
  render() {
    const withToggleStyle = this.props.visible ? {} : { display: 'none' }
    const rowKey = this.props.name.split('_row_')[1]

    return this.props.items.map(item => (
      <Grid.Row style={withToggleStyle} key={`item-${item.jsonref}`}>
        <SelectField
          key={`item-${item.jsonref}`}
          label={item.value}
          name={item.key}
          selectOptions={item.values}
          forceNativeSelect={true}
          renderAs={this.props.renderAs}
          parentDisabled={this.props.parentDisabled || this.props.disabled || this.props.rowComment === ''}
          currentPageName={this.props.currentPageName}
          questionName={this.props.name}
          jsonref={`${this.props.currentPageName}.${this.props.group}_col_${item.key}`}
          questionSkipped={this.props.questionSkipped || false}
          className={`matrix-cell cell-${rowKey}-${item.key}`}
        />
      </Grid.Row>
    ))
  }
}
_List.displayName = '_List'

const SelectListWithComment = withToggle(connect(mstp)(_List))
const SelectList = withToggle(_List)

const MobileBody = props => {
  let childQuestions = props.childQuestions || []
  return childQuestions.map(q => {
    const childProps = {
      key: `key-${q.name}`,
      name: q.name,
      parentDisabled: props.questionSkipped || props.disabled,
      currentPageName: props.currentPageName,
      group: props.name,
      renderAs: props.options.render_as,
      jsonref: q.jsonref,
      items: q.items,
      qtext: q.qtext[0],
      hasComment: typeof q.has_comment !== 'undefined',
      withToggleStyle: props.visible ? {} : { display: 'none' },
    }

    return <MobileMSelectItem {...childProps} />
  })
}

const MobileMSelectItem = withToggle(props => {
  let { qtext, hasComment, withToggleStyle, ...listProps } = props
  let List = hasComment ? SelectListWithComment : SelectList
  return (
    <React.Fragment key={props.name}>
      <Grid.Row style={withToggleStyle}>
        <Grid.Column>
          <Qtext {...qtext} {...props} />
          {hasComment === true && (
            <CommentItemField
              label=""
              disabled={props.questionSkipped || props.disabled}
              visible={props.visible}
              name={`_rowcomment`}
              questionName={props.name}
              currentPageName={props.currentPageName}
              jsonref={`${props.currentPageName}.${props.name}.comment_matrix`}
            />
          )}
        </Grid.Column>
      </Grid.Row>

      <List {...listProps} />
    </React.Fragment>
  )
})

export default MobileBody
